import { inject, Injectable } from '@angular/core';
import { StepResolverStrategy } from './step-resolver.strategy';
import { Step } from '../../types';
import { Observable, of } from 'rxjs';
import { AyaQuoteStepDefinitionService } from '../step-definition/aya-quote-step-definition.service';
import { Flow } from '@lx/quote-tool/lite/shared/types';

@Injectable({
  providedIn: 'root',
})
export class AyaQuoteStepResolverService implements StepResolverStrategy {
  private readonly ayaQuoteStepDefinitionService = inject(AyaQuoteStepDefinitionService);

  resolve(activeFlow: Flow): Observable<Step> {
    return of(this.ayaQuoteStepDefinitionService.getStepDefinition(activeFlow));
  }
}
